import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {LorenBaseFeature} from '../../../../shared/base-components/loren-base-feature/loren-base-feature';
import {LorenEntityFormModel} from '../../../../shared/modules/loren-entity-form-card/interfaces/loren-entity-form-model.interface.ts';
import {LorenFieldTypes} from '../../../../shared/modules/loren-entity-form-card/enums/loren-field-types.enum';
import {LorenFormSubmission} from '../../../../shared/modules/loren-entity-form-card/interfaces/loren-form-submission.interface';
import {LorenAuthenticationEndpointsService} from '../../../../shared/services/loren-authentication-service/loren-authentication-endpoints.service';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'loren-forgotten-password',
    templateUrl: './loren-forgotten-password.component.html',
    styleUrls: ['./loren-forgotten-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenForgottenPasswordComponent extends LorenBaseFeature implements OnInit, OnDestroy {
    protected lorenAuthenticationEndpointsService = inject(LorenAuthenticationEndpointsService);
    protected http = inject(HttpClient);


    constructor() {
        super();

        document.body.className = !this.isHandset ? 'login-background' : 'login-background-mobile';
    }

    private static readonly USERNAME_EMAIL_FIELD_NAME: string = 'username_or_email';

    emailSent: boolean;
    formModel: LorenEntityFormModel;
    disableSubmitBtn: boolean;

    ngOnInit(): void {
        this.formModel = {
            formName: '',
            formFields: [
                {
                    name: LorenForgottenPasswordComponent.USERNAME_EMAIL_FIELD_NAME,
                    label: `forgotten_password.${LorenForgottenPasswordComponent.USERNAME_EMAIL_FIELD_NAME}`,
                    formControlType: LorenFieldTypes.INPUT,
                    validator: {
                        required: true,
                        minLength: 4,
                        maxLength: 255
                    },
                    options: []
                },
            ]
        };

        this.disableSubmitBtn = true;
    }

    ngOnDestroy(): void {
        document.body.className = '';
    }

    submit(formSubmission: LorenFormSubmission) {
        if (formSubmission.valid) {
            this.http.post(this.lorenAuthenticationEndpointsService.forgottenPassword(), {
                usernameOrEmail: formSubmission.value[LorenForgottenPasswordComponent.USERNAME_EMAIL_FIELD_NAME]
            }).subscribe(() => {
                this.emailSent = true;
            });
        }
    }

}
